import { render, staticRenderFns } from "./SlipMain.vue?vue&type=template&id=a1300e86&scoped=true"
import script from "./SlipMain.vue?vue&type=script&lang=js"
export * from "./SlipMain.vue?vue&type=script&lang=js"
import style0 from "./SlipMain.vue?vue&type=style&index=0&id=a1300e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1300e86",
  null
  
)

export default component.exports